export default __webpack_public_path__ + "static/media/pricing1.214ce3b7.jpg";